import graphql from "babel-plugin-relay/macro";
import { ChangeEmail } from "components/account/ChangeEmail";
import { ErrorMessage } from "components/shared/ErrorMessage";
import { LoadingRegion } from "components/shared/LoadingRegion";
import { ResendCode } from "components/user/ResendCode";
import { VerifyCode } from "components/user/VerifyCode";
import { userMessages } from "domain/user/userMessages";
import { VerifyQuery } from "generatedQueries/VerifyQuery.graphql";
import { FC } from "react";
import { AccordionSelection } from "shared/components/AccordionSelection";
import { Message } from "shared/components/Message";
import { Query } from "shared/components/Query";
import { sharedMessages } from "shared/sharedMessages";

export const Verify: FC = () => {
    return <main>
        <h1 className="h2"><Message message={userMessages.verifyYourAccountTitle} /></h1>
        <Query<VerifyQuery>
            query={graphql`
                query VerifyQuery {
                    account {
                        email
                        ...ResendCode_account
                    }
                }`}
            variables={{}}>
            {({ error, props }) => (
                <LoadingRegion hasError={!!error} isLoading={!props} contentName={userMessages.verifyYourAccountTitle}>
                    {(() => {
                        if (error) {
                            return <ErrorMessage message={sharedMessages.requestFailedBody} heading={sharedMessages.requestFailedTitle} />;
                        }

                        if (!props) {
                            return null;
                        }

                        const { account } = props;

                        if (!account) {
                            return <ErrorMessage message={sharedMessages.requestFailedBody} heading={sharedMessages.requestFailedTitle} />;
                        }

                        return <>
                            <p className="lead">
                                <Message message={userMessages.verifyLeadMessage} values={({ email: account?.email })} />
                            </p>
                            <AccordionSelection name="verifyOption">
                                {{
                                    options: [
                                        {
                                            children: <VerifyCode />,
                                            message: userMessages.verifyOptionReceivedLabel,
                                            option: "Received",
                                        },
                                        {
                                            children: <ResendCode account={account} />,
                                            message: userMessages.verifyOptionNotReceivedLabel,
                                            option: "NotReceived",
                                        },
                                        {
                                            children: <ChangeEmail />,
                                            message: userMessages.verifyOptionIncorrectEmailLabel,
                                            option: "IncorrectEmail",
                                        },
                                    ],
                                }}
                            </AccordionSelection>
                        </>;
                    })()}
                </LoadingRegion>
            )}
        </Query>
    </main>;
};
